import { useEffect, useSyncExternalStore } from 'react';
import { sessionStore } from '../services/sessionStore';

/**
 * The admin's session as React state: `{ status, endReason }`. Starts
 * restoring a stored session on first use.
 *
 * The tokens are not part of it; requests get the token on their own. Renewing
 * the access token leaves the value unchanged, so it re-renders nothing.
 */
export const useSession = () => {
  const session = useSyncExternalStore(sessionStore.subscribe, sessionStore.getSnapshot);

  useEffect(() => {
    sessionStore.start();
  }, []);

  return session;
};
